export const hasOwn = <RecordKeys extends string>(
  record: Readonly<Record<RecordKeys, unknown>>,
  key: string
): key is RecordKeys => {
  return Object.prototype.hasOwnProperty.call(record, key);
};
